import { createAction } from "@reduxjs/toolkit";
import { ACME_RECEIVED } from "state/actionTypes";
import { ReceivedAcmeIdType } from "state/tree/receivedAcmeIds";

export const actions = {
  saveAcmeId: createAction<ReceivedAcmeIdType>(ACME_RECEIVED),
  clearAcmeIds: createAction("lwc/receivedAcmeIds/clear"),
};
